<template>
  <div class="wrapper">
    <iframe
      :src="calendar"
      width="100%"
      height="100%"
      scrolling="yes"
      style="border: 0"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import helpers from '@/mixins/helpers'

export default {
  // mixins: [ helpers ],
  props: {},
  data: () => ({}),
  computed: {
    ...mapGetters(['_pageLayout']),
    calendar () {
      return process.env.VUE_APP_BOOKINGS_CALENDAR
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  height: 100%;
  background: #F4F4F4;
  padding: 32px 0;
}
</style>